function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "euro-lemon_svg__a",
  d: "M0 276h327.69V.84H0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#231F20",
  d: "M4.391 184.915h9.183v-9.182H4.391z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M0 178.982h9.182V169.8H0z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M4.824 173.049h9.183v-9.182H4.824zM206.442 240.576v-10.348l21.342-28.311H207.16v-12.359h39.449v10.132l-21.413 28.527h21.701v12.359zM209.022 60.847h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M213.514 54.942h9.183V45.76h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M217.905 49.037h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M213.081 43.132h9.183V33.95h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M176.221 37.227h41.385v-9.182h-41.385zM281.946 106.946h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M277.555 112.878h9.182v-9.182h-9.182zM286.437 101.013h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M290.829 95.08h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M286.005 89.148h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M281.348 83.214h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M278.685 77.282h9.183V68.1h-9.183zM77.016 233.897h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M81.407 239.829h9.183v-9.182h-9.183zM72.525 227.964h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M68.133 222.031h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M72.956 216.098h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M77.615 210.166h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M80.276 204.232h9.182v-9.182h-9.182zM27.513 109.075h10.313v-9.182H27.513z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M31.904 115.008h9.183v-9.182h-9.183zM23.022 103.142h9.182V93.96h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M18.63 97.21h9.182v-9.182H18.63z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M23.454 91.276h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M28.112 85.344h10.246v-9.182H28.112z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M30.773 79.411h9.183v-9.182h-9.183zM26.648 102.233H42.35v-18.63H26.648zM307.962 192.644h10.313v-9.182h-10.313z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M305.233 198.577h9.183v-9.182h-9.183zM313.683 186.711h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M318.508 180.779h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M313.683 174.846h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M307.962 168.913h10.246v-9.182h-10.246z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M305.233 162.98h9.183v-9.182h-9.183zM8.882 190.848h9.183v-9.182H8.882z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M13.274 196.78h9.183v-9.182h-9.183zM9.482 167.117h9.182v-9.182H9.482z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M12.143 161.184h9.182v-9.182h-9.182zM8.018 184.005H23.72v-18.63H8.018zM253.56 202.527l-7.252-5.632-5.632 7.252 7.252 5.631z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M253.731 195.148l-7.252-5.632-5.632 7.252 7.252 5.631zM253.468 209.967l-7.252-5.632-5.632 7.252 7.252 5.632z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M253.297 217.346l-7.252-5.632-5.632 7.252 7.252 5.632z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M245.849 219.073l-7.252-5.632-5.632 7.252 7.252 5.632z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M238.531 220.902l-7.251-5.632-5.632 7.252 7.251 5.631z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M237.645 198.83l12.401 9.631-11.426 14.714-12.402-9.631zM98.174 70.351h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M102.566 76.284h9.182v-9.182h-9.182zM81.008 66.303h9.182v-9.182h-9.182zM152.367 27.147h9.182v-9.182h-9.182zM178.915 18.065h9.182V8.883h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M178.915 33.301h9.182V17.965h-9.182zM161.151 18.065h9.182V8.883h-9.182zM72.99 215.843h9.182v-9.182H72.99zM150.738 242.945h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M155.129 248.878h9.182v-9.182h-9.182zM146.246 237.013h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M141.855 231.08h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M146.679 225.147h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M151.336 219.214h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M153.997 213.281h9.183v-9.182h-9.183zM146.712 224.892h9.182v-9.182h-9.182zM168.036 242.945h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M163.645 248.878h9.182v-9.182h-9.182zM172.527 237.013h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M176.919 231.08h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M172.095 225.147h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M167.437 219.214h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M164.776 213.281h9.182v-9.182h-9.182zM172.062 224.892h9.183v-9.182h-9.183zM64.207 206.761h9.182v-9.182h-9.182zM169.999 9.182h9.183V0h-9.183zM271.6 228.352h9.183v-9.182H271.6z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M280.383 219.27h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M289.232 210.387h9.183v-9.182h-9.183zM226.988 57.787h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M236.169 57.787h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M245.219 71.36h9.182V57.387h-9.182zM253.202 237.234h9.183v-9.182h-9.183zM262.385 237.234h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M271.434 250.808h9.182v-13.973h-9.182zM244.42 241.359h9.182v-9.182h-9.182zM93.517 249.344h9.182v-9.182h-9.182zM113.743 252.272h9.182v-9.182h-9.182zM159.254 261.586h9.182v-9.182h-9.182zM122.792 261.454h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M131.575 257.062h9.182v-9.182h-9.182zM167.504 267.176h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M176.154 275.16h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M184.537 267.176h9.183v-9.182h-9.183z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M193.52 258.193h9.183v-9.182h-9.183zM202.436 248.878h9.182v-9.182h-9.182zM85.399 251.739h9.183v-13.973h-9.183zM254.401 70.828h26.415v-9.182h-26.415zM110.35 81.474h28.145v-9.182H110.35zM93.683 64.418h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M89.291 58.485h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M94.116 52.553h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M98.773 46.62h9.182v-9.182h-9.182z"
}), React.createElement("path", {
  fill: "#231F20",
  d: "M101.434 40.687h9.183v-9.182h-9.183zM97.309 63.509h15.702v-18.63H97.309zM149.074 235.305h17.034V221.2h-17.034zM168.503 236.37h9.315v-20.493h-9.315zM36.895 65.222h45.378v13.069H54.592v8.199h24.957v12.528H54.592v7.811h28.407v13.302H36.895z"
}), React.createElement("g", {
  transform: "translate(0 -.84)"
}, React.createElement("path", {
  fill: "#231F20",
  d: "M104.993 27.775h15.083v32.018c0 7.114 3.556 10.518 8.894 10.518 5.335 0 8.893-3.404 8.893-10.518V27.775h14.849V60.41c0 15.39-8.74 23.433-23.742 23.433-15.004 0-23.977-8.043-23.977-23.433V27.775zm86.448 14.693v10.827h7.115c4.33 0 6.729-2.319 6.729-5.413 0-3.094-2.398-5.414-6.73-5.414h-7.114zm0 23.588v17.788h-15.08v-54.91h23.742c13.225 0 21.035 7.734 21.035 17.711 0 6.186-3.247 11.832-9.125 14.926 2.939 1.624 4.33 3.867 5.18 6.96l1.47 5.645c1.006 3.867 1.857 6.419 4.023 9.668h-15.623c-1.16-1.238-2.165-3.403-2.784-5.801l-2.165-8.429c-.618-2.475-1.78-3.558-4.563-3.558h-6.11zM32.675 175.158v28.46H18.059v-54.91h11.678l22.427 27.687v-27.687h14.539v54.91H55.258zM104.9 234.093c7.579 0 12.528-6.342 12.528-15.081s-4.95-15.081-12.528-15.081c-7.58 0-12.528 6.342-12.528 15.081s4.949 15.081 12.528 15.081m0-43.695c17.092 0 28.383 12.218 28.383 28.614s-11.291 28.615-28.383 28.615c-17.091 0-28.383-12.219-28.383-28.615s11.292-28.614 28.383-28.614m158.645-83.256c7.58 0 12.528-6.342 12.528-15.08 0-8.74-4.949-15.082-12.528-15.082-7.579 0-12.528 6.342-12.528 15.081 0 8.74 4.95 15.081 12.528 15.081m0-43.695c17.092 0 28.382 12.218 28.382 28.614s-11.29 28.615-28.382 28.615c-17.09 0-28.383-12.219-28.383-28.615s11.292-28.614 28.383-28.614"
}), React.createElement("mask", {
  id: "euro-lemon_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#euro-lemon_svg__a"
})), React.createElement("path", {
  fill: "#231F20",
  mask: "url(#euro-lemon_svg__b)",
  d: "M156.002 254.452h15.08v-54.91h-15.08zM267.855 148.708h38.668v13.07h-23.588v8.198h21.268v12.528h-21.268v7.811h24.207v13.303h-39.287z"
}), React.createElement("path", {
  fill: "#89C190",
  mask: "url(#euro-lemon_svg__b)",
  d: "M69.364 101.476h14.372V85.907H69.364zM107.954 101.942h50.302V82.181h-50.302z"
})));

var SvgEuroLemon = function SvgEuroLemon(props) {
  return React.createElement("svg", _extends({
    width: 328,
    height: 276
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/euro-lemon.e289eaa2.svg";
export { SvgEuroLemon as ReactComponent };